import { GameEntity } from "../GameEntity/GameEntity";
const redColor = "#FF0000";
const blackColor = "#FFFFFF";

class Bullet extends GameEntity {
  constructor(x, y, game, isEnemyBullet) {
    const width = 10;
    const height = 5;
    const velocityY = isEnemyBullet ? 0.4 : -0.4;

    super(game, width, height, redColor, velocityY);

    this.x = x;
    this.y = y - this.height / 2;
  }

  update(deltaTime) {
    super.update(deltaTime);
    
    if (this.y + this.height < 0) this.markedForDeletion = true;
  }

  draw(ctx) {
    ctx.fillStyle = this.velocityY === -0.4 ? blackColor : redColor;
    ctx.fillRect(this.x, this.y, this.width, this.height);
  }
}

export { Bullet };
